import React, { FunctionComponent } from 'react';

import { InsuredItem, SingleFieldStepProps } from 'scenes/common/types';
import SingleYesNoStep from 'scenes/common/components/Steps/SingleYesNoStep';

export const PROPERTY_UNOCCUPIED = 'propertyUnoccupied';

const PropertyUnoccupiedStep: FunctionComponent<
  Pick<SingleFieldStepProps<string>, 'onNext' | 'defaultStateValue'> & {
    insuredItem: InsuredItem;
  }
> = ({ onNext, defaultStateValue, insuredItem }) => {
  const question = `Do you expect the ${insuredItem} to be unoccupied for more than 60 days in a row during the year of the policy?`;
  return (
    <SingleYesNoStep
      question={question}
      stateKey={PROPERTY_UNOCCUPIED}
      defaultStateValue={defaultStateValue}
      onNext={onNext}
    />
  );
};

export default PropertyUnoccupiedStep;
